module.exports = __webpack_public_path__ + "img/es-bottom.c9c01ba6.png";